export default "__VITE_ASSET__e1725c81__"